 <template>
  <div>
    <v-card class="elevation-0 mt-2 transparent">
      <v-layout justify-left>
        <img class="lindaLogo" :src="getLindaImage(lindaIcon)">
        <v-card
          round
          color="#f2f2f2"
          :class="['lindaText tri-right left-in elevation-1', (lindaText1.length + lindaText2.length < 110) ? 'lindaTextSmall' : 'lindaTextMedium']"
        >
          <v-card-text>
            <p class="fontSize" :style="getFontProperty()">{{lindaText1}}</p>

            <p v-if="lindaText2 != null" class="fontSize" :style="getFontProperty()">{{lindaText2}}</p>
          </v-card-text>
          <v-spacer></v-spacer>
          <img
            class="mt-2 recycle_icon"
            src="../assets/round_messages_icon.png"
            alt="message cycle"
          >
        </v-card>
      </v-layout>
    </v-card>
  </div>
</template>


<script>
import appConfig from "../../config/app_config.js";
import * as dssRequest from "../api/dssRequest";
import { mapGetters } from "vuex";
import { ui_helpers } from "../shared/ui_helpers.js";
import BaseComponent from "./base/BaseComponent.vue";

export default {
  extends: BaseComponent,
  mixins: [ui_helpers],
  name: "LindaOutputDynamic",

  computed: {
    ...mapGetters({
      _webStep: "getWebStepId"
    })
  },

  props: {
    lindaIcon: String,
    lindaText1: String,
    lindaText2: String,
    lindaBubbleSize: String
  },

  data() {
    return {};
  },

  created() {
    if (this.$attrs.linda_text != undefined) {
    }
  },

  methods: {
    getLindaImage(name) {
      return this.customerPreferences[name];
    }
  }
};
</script>
<style>
.lindaLogo {
  height: 25em;
  margin-left: -5em;
}

.lindaText {
  max-height: 15em;
  margin-left: -2.5em !important;
  margin: 15px;
  border-radius: 30px !important;
  max-width: 21em !important;
}

.lindaTextSmall {
  max-height: 8em;
  margin-left: -2.5em !important;
  margin: 15px;
  border-radius: 30px !important;
  max-width: 21em !important;
}

.lindaTextMedium {
  max-height: 14em;
  margin-left: -2.5em !important;
  margin: 15px;
  border-radius: 30px !important;
  max-width: 21em !important;
}
.fontSize {
  font-size: 18px;
}

.fontSize2 {
  font-size: 16px;
}

.tri-right.left-in:after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: -25px;
  right: auto;
  top: 30px;
  bottom: auto;
  border: 13px solid;
  border-color: #f2f2f2 #f2f2f2 transparent transparent;
}

.recycle_icon {
  max-height: 130px !important;
}

@media screen and (max-width: 960px) {
}
</style>
